import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, ArrowRight, Trash2 } from 'lucide-react';
import { useCart } from '../hooks/useCart';
import { CartItem } from '../components/cart';
import { CartSummary } from '../components/cart';
import { Button } from '../components/common';

const CartPage: React.FC = () => {
  const { items, updateQuantity, removeFromCart, clearCart, itemCount } = useCart();

  if (itemCount === 0) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center bg-dark-dark dark:bg-white transition-colors duration-300">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 bg-dark-light dark:bg-gray-100 rounded-full flex items-center justify-center transition-colors duration-300">
            <ShoppingCart className="w-10 h-10 md:w-12 md:h-12 text-gray-400 dark:text-gray-500 transition-colors duration-300" />
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-white dark:text-dark-dark mb-4 transition-colors duration-300">
            Your cart is empty
          </h2>
          <p className="text-gray-400 dark:text-gray-500 mb-8 transition-colors duration-300">
            Looks like you haven't added any products to your cart yet.
          </p>
          <Button
            variant="primary"
            size="lg"
            to="/products"
            as={Link}
            rightIcon={<ArrowRight className="w-5 h-5" />}
          >
            Start Shopping
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-dark dark:bg-gray-50 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 md:mb-8">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white dark:text-dark-dark transition-colors duration-300">
              Shopping Cart
            </h1>
            <p className="text-gray-400 dark:text-gray-500 mt-1 text-sm md:text-base transition-colors duration-300">
              {itemCount} {itemCount === 1 ? 'item' : 'items'} in your cart
            </p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            leftIcon={<Trash2 className="w-4 h-4" />}
            onClick={clearCart}
            className="self-start sm:self-auto"
          >
            Clear Cart
          </Button>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Cart Items */}
          <div className="lg:col-span-2 space-y-3 md:space-y-4">
            {items.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                onUpdateQuantity={updateQuantity}
                onRemove={removeFromCart}
              />
            ))}
          </div>

          {/* Cart Summary */}
          <div className="lg:col-span-1">
            <CartSummary />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;